// Componentes bases
import './_base/button/';
import './_base/container/';
import './_base/heading/';
import './_base/image/';
import './_base/paragraph/';

// Componentes revisados
import './about-us-cards/';
import './about-us-cards/about-us-cards-card/';
import './accordion/';
import './accordion/accordion-item/';
import './advantages/';
import './advantages/advantage/';
import './cards-dropdown/';
import './cards-dropdown/item-drop-cards/';
import './card/';
import './color-cards/';
import './color-cards/card/';
import './contact-us/';
import './contact-us/card/';
import './cta-text/';
import './divider/';
import './form-cupom/';
import './grid-buttons/';
import './grid-cards/';
import './grid-image-text/';
import './grid-sumicity/';
import './hero/';
import './image-with-topics/';
import './info/';
import './locations/';
import './locations/locate-selector';
import './locations/locate-selector/list-cities';
import './middle-banner/';
import './search-bar/';
import './section-map/';
import './self-service/';
import './self-service/card/';
import './short-form/';
import './solution-section/';
import './solution-section/item-solution-section/';
import './streaming-content/';
import './streaming-content/card/';
import './swiper/';
import './table/';
import './tabs-sumicity/';
import './tabs-sumicity/tab';
import './topics/';

// Componentes revisados que precisam de correções
import './form-hero/';
import './form-section/';
import './plans-api/';
import './plans-company/';
import './plans-corporate/';
import './plans-corporate/plans-corporate-item';
import './plans-corporate/plans-corporate-item/checklist-item';
import './plans-no-tabs/';
import './plans-tabs/';
import './tabs/';
import './tabs/tab/';
import './tabs-company/';
import './tabs-company/tab-item/';

import './plans-all-services';

import './grid-plans';
import './plans-details';
import './whatsapp-card';
